export default __webpack_public_path__ + "static/media/icons_home.b3673a9c.svg";